export default function Heading({
  title,
  description,
  marginBottom = true,
}: {
  title: string
  description?: string
  marginBottom?: boolean
}) {
  return (
    <div className={`${marginBottom ? "mb-8" : ""} space-y-0.5`}>
      <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
      {description && (
        <p className="text-muted-foreground text-sm">{description}</p>
      )}
    </div>
  )
}
